import { render, staticRenderFns } from "./CartImportSummary.vue?vue&type=template&id=153aba58&"
import script from "./CartImportSummary.vue?vue&type=script&lang=js&"
export * from "./CartImportSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports